module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="widget_header_region"></div>\n<div id="interactive_region"></div>\n<div id="photowall_widget" class="wrap">\n	<div class="photowall_frame">\n	</div>\n	<div id="photowall_control" class="controls">\n        <button class="load_more">' +
((__t = ( I18n.t('widget.load_more') )) == null ? '' : __t) +
'</button>\n	</div>\n</div>\n';

}
return __p
}